angular.module('wbDashboard').controller('ProfileControllerAurea',
    ['$scope', '$state', '$timeout', '$uibModal', 'User', 'PlanService', 'Misc', 'Message', 'PlanningService',
function ($scope, $state, $timeout, $uibModal, User, PlanService, Misc, Message, PlanningService) {

    $scope.pageData = {
        sending: false,
        errorMsg: null
    };

    $scope.forms = {};
    $scope.validation = Misc.validation;

    $scope.userDetailsOrig = {};
    $scope.userDetails = {};
    $scope.bank = {};

    $scope.options = {};
    $scope.options.employmentStatus = Misc.employment_status;
    $scope.options.occupation = Misc.occupations;
    $scope.options.income = Misc.income_levels;
    $scope.options.accountType = Misc.bank_account_types;
    $scope.options.state = Misc.states;
    $scope.options.suffixes = Misc.suffixes;

    $scope.planning = PlanningService;

    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            $scope.overview = overview;
            $scope.closed = overview.user.is_closed;
            $scope.fullName = overview.user.first_name + " " + overview.user.last_name;
            $scope.foundingMember = overview.user.flags.founding_member;

        }
    });

    User.retrieveDetail();
    $scope.$watch(User.getDetail, function(detail) {
        if (detail) {
            $scope.userDetailsOrig = detail;
            $scope.userDetails = angular.copy($scope.userDetailsOrig);
        }
    });

    $scope.$watch(function() { return PlanService.get('discountRate'); }, function(discountRate) {
        if (discountRate) {
            $scope.discount = discountRate * 100;
        }
    });

    $scope.userSubmit = function() {

        var submitDetails = angular.copy($scope.userDetails);
        var data = {
            detail: submitDetails.detail,
            employer: submitDetails.employer,
            affiliated_company: submitDetails.affiliated_company,
        };
        delete data.detail.net_worth;
        delete data.detail.social;
        delete data.detail.legal_name;
        delete data.detail.birth_date;
        delete data.employer.industry;
        delete data.employer.country;

        if (['unemployed','retired','student'].includes(data.employer.status)) {
            delete data.employer.address;
            delete data.employer.address_continued;
            delete data.employer.zip_code;
            delete data.employer.city;
            delete data.employer.state;
            delete data.employer.occupation;
            delete data.employer.company_name;
        }

        if (!data.affiliated_company.is_affiliated) {
            data.affiliated_company = {is_affiliated: false};
        }

        $scope.pageData.sending = true;
        $scope.pageData.errorMsg = null;
        return User.updateDetail(data).then(function(userDetail) {
            Message.set({
                "text" : "Your information has been updated.",
                "type" : "success"
            });
        }).catch(function (response) {
            if (response.status === 412) {
                Message.set({
                    "text" : "There was an issue with your Two Factor token.",
                    "type" : "warning"
                });
            } else if (response.data.code === 400 && response.data.details && response.data.details[0].target === "has_pending_accounts") {
                $scope.pageData.errorMsg = "Since you have pending accounts, we are unable to update your profile at this time. Please email support@axosinvest.com if you have any questions.";
            } else {
                $scope.pageData.errorMsg = "There was an error updating your profile. Please email support@axosinvest.com.";
                throw response;
            }
        }).then(function (response) {
            return User.retrieveDetail(true);
        }).finally(function () {
            $scope.pageData.sending = false;
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onSuccess({ to: "base.profile.**" }, function() {
        if ($scope.userDetailsOrig) {
            //reset data to stock if page is changed
            $scope.userDetails = angular.copy($scope.userDetailsOrig);
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
